import styled from "styled-components";

export const DateContainerDefault = styled.div`
  &&& {
    display: flex;
    align-items: center;
    justify-content: start;

    & label {
      z-index: 1;
      transform: translate(12px, 17px) scale(1) !important;
    }
    
    & .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-shrink.MuiFormLabel-filled,
    & label.Mui-focused {
      transform: translate(12px, 7px) scale(0.75) !important;
    }

    & .MuiFormControl-root {
      width: 100%;
      width: 100%;
    }

    &
      .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-formControl.MuiInput-formControl {
      margin-top: 0;
      overflow: hidden;
      background: #fff;
      border-radius: 0.5rem;
      padding-top: 15px;
      padding-bottom: 6px;
      padding-left: 12px;
      padding-right: 12px;
    }

    & p.MuiFormHelperText-root {
      margin-top: 4px;
      margin-left: 14px;
      margin-right: 14px;
    }

    & .MuiInput-underline:after {
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      position: absolute;
      transform: scaleX(0);
      transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
      border-bottom: 2px solid ${({ theme }) => theme.pantone2726C};
      pointer-events: none;
    }
    & .MuiInput-underline.Mui-focused:after {
      transform: scaleX(1) !important;
    }
    & .MuiInput-underline:before {
      border-bottom: none !important;
    }
    & .MuiInput-underline.Mui-error:after {
      transform: scaleX(1);
      border-bottom: 2px solid ${({ theme }) => theme.red} !important;
    }
    
    @media (max-width: 560px) {
      flex-direction: column;
      & .MuiFormControl-root {
        width: 100%;
        margin: 0.25rem 0rem;
      }
    }
  }
`;